var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// TODO: This file needs to be refactored to be more type-safe.
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { normalizeColor } from 'grommet/utils';
var colorStyle = function (name, value, theme, required) { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ": ", ";\n"], ["\n  ", ": ", ";\n"])), name, normalizeColor(value, theme, required)); };
var colorCss = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n  g {\n    fill: inherit;\n    stroke: inherit;\n  }\n  *:not([stroke]) {\n    &[fill='none'] {\n      stroke-width: 0;\n    }\n  }\n  *[stroke*='#'],\n  *[STROKE*='#'] {\n    stroke: inherit;\n    fill: none;\n  }\n  *[fill-rule],\n  *[FILL-RULE],\n  *[fill*='#'],\n  *[FILL*='#'] {\n    fill: inherit;\n    stroke: none;\n  }\n"], ["\n  ", "\n  ", "\n  g {\n    fill: inherit;\n    stroke: inherit;\n  }\n  *:not([stroke]) {\n    &[fill='none'] {\n      stroke-width: 0;\n    }\n  }\n  *[stroke*='#'],\n  *[STROKE*='#'] {\n    stroke: inherit;\n    fill: none;\n  }\n  *[fill-rule],\n  *[FILL-RULE],\n  *[fill*='#'],\n  *[FILL*='#'] {\n    fill: inherit;\n    stroke: none;\n  }\n"])), function (props) {
    return colorStyle("fill", props.color || props.theme.global.colors.icon, props.theme);
}, function (props) {
    return colorStyle("stroke", props.color || props.theme.global.colors.icon, props.theme);
});
var IconInner = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function (_a, ref) {
    var a11yTitle = _a.a11yTitle, color = _a.color, size = _a.size, theme = _a.theme, rest = __rest(_a, ["a11yTitle", "color", "size", "theme"]);
    return (_jsx("svg", __assign({ ref: ref, "aria-label": a11yTitle }, rest)));
});
IconInner.displayName = "Icon";
var parseMetricToNum = function (string) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return parseFloat(string.match(/\d+(\.\d+)?/));
};
var StyledIcon = styled(IconInner)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, theme = _a.theme, viewBox = _a.viewBox;
    var _c = (viewBox || "0 0 24 24").split(" "), w = _c[2], h = _c[3];
    var scale = w / h;
    var dimension = parseMetricToNum(theme.icon.size[size] || size);
    if (w < h) {
        return "\n      width: ".concat(dimension, "px;\n      height: ").concat(dimension / scale, "px;\n    ");
    }
    if (h < w) {
        return "\n      width: ".concat(dimension * scale, "px;\n      height: ").concat(dimension, "px;\n    ");
    }
    return "\n      width: ".concat(dimension, "px;\n      height: ").concat(dimension, "px;\n    ");
}, function (_a) {
    var color = _a.color;
    return color !== "plain" && colorCss;
}, function (_a) {
    var theme = _a.theme;
    return theme && theme.icon.extend;
});
StyledIcon.defaultProps = {};
export { StyledIcon };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=StyledIcon.js.map